import { string, shape, number, arrayOf, oneOfType } from 'prop-types';

const RegisteredBusPropTypes = {
  id: number,
  companyBusId: string.isRequired,
};

const ItinerarySupplierFoodInvoiceItemPropTypes = {
  id: number.isRequired,
  itineraryId: number.isRequired,
  originLocationName: string.isRequired,
  destinationLocationName: string.isRequired,
  registeredBusId: number.isRequired,
  registeredBus: shape(RegisteredBusPropTypes).isRequired,
};

const ItineraryFoodInvoicePropTypes = {
  id: number.isRequired,
  supplierId: number.isRequired,
  supplierBusinessTaxId: string.isRequired,
  supplierBusinessName: string.isRequired,
  documentSeries: string.isRequired,
  documentCode: oneOfType([number, string]).isRequired,
  billingDate: oneOfType([number, string]).isRequired,
  periodStartDate: oneOfType([number, string]).isRequired,
  periodEndDate: oneOfType([number, string]).isRequired,
  createDate: oneOfType([number, string]),
  itinerarySupplierFoodList: arrayOf(
    shape(ItinerarySupplierFoodInvoiceItemPropTypes),
  ).isRequired,
};

export default ItineraryFoodInvoicePropTypes;
